import { render, staticRenderFns } from "./CheckinPage.vue?vue&type=template&id=28d11fc8&scoped=true"
import script from "./CheckinPage.vue?vue&type=script&lang=js"
export * from "./CheckinPage.vue?vue&type=script&lang=js"
import style0 from "./CheckinPage.vue?vue&type=style&index=0&id=28d11fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d11fc8",
  null
  
)

export default component.exports